/**
 * 결제 차단 사유 코드 — 서버/클라이언트 단일 출처.
 *
 * 서버(`/api/order/checkout`)가 차단 시 응답 body 의 `code` 로 내려주고, 클라이언트는
 * 이 값을 string 비교로 분기(예: NON_SHIPPABLE_COUNTRY → 국가 선택 다이얼로그)한다.
 * 양쪽이 같은 상수를 import 해야 한쪽만 리네임돼도 컴파일에서 잡혀 desync(다이얼로그
 * silent 실패)를 막을 수 있다.
 */
export const CHECKOUT_ERROR_CODE = {
  /** 비배송(비판매) 국가 — 배송 가능국 목록에 없음. FE 가 국가 선택 다이얼로그를 띄운다. */
  NON_SHIPPABLE_COUNTRY: "NON_SHIPPABLE_COUNTRY",
  /** 음수 배송비 (백엔드 계산 오류) — under-charge 방지로 차단. */
  NEGATIVE_SHIPPING_PRICE: "NEGATIVE_SHIPPING_PRICE",
  /** 배송 가능국 목록 조회 실패 — fail-open(차단 안 함)이지만 추적용 기록. */
  SHIPPABLE_LIST_UNAVAILABLE: "SHIPPABLE_LIST_UNAVAILABLE",
  /**
   * mgmt 주문 드래프트가 **해당 통화를 아직 수용하지 않아** 실패했을 가능성이 높은 경우.
   *
   * 실측(2026-08-11): 동일 페이로드로 `USD`/`JPY`/`KRW` 는 생성 성공, `EUR`/`GBP` 는 400.
   * mgmt 허용 통화가 3종이라 EU/GB 카트가 자체 결제로 빠지면(무게·배터리로 GE 라우팅이
   * 막히는 경우) 여기서 죽는다. 일반 실패("Failed to create order")와 섞이면 원인 추적이
   * 안 돼서 별도 코드로 분리했다. mgmt 가 EUR/GBP 를 받으면(admin#1445) 자연히 사라진다.
   */
  CURRENCY_NOT_SUPPORTED_UPSTREAM: "CURRENCY_NOT_SUPPORTED_UPSTREAM",
  /**
   * 단품 게임 키가 **품절**이거나 재고를 **확인하지 못한**(모름) 게임 줄이 있다 — 409. 응답 `gameItems` 에 줄별 상태.
   *
   * 장바구니가 같은 판정으로 이미 결제를 막지만(docs/cart-game-key-stock-policy.md §1.2) 클라가 본 재고는 최대 60초 전
   * 값이라 서버가 다시 본다. FE 는 키 재고를 다시 물어 장바구니가 줄별 이유를 보여주게 한다 — 카트 버튼은 안내창까지,
   * `useShoppingBagCheckout` 은 `/cart` 로 보낸다(정책 §2.1).
   */
  GAME_KEY_STOCK_UNAVAILABLE: "GAME_KEY_STOCK_UNAVAILABLE",
} as const;

export type CheckoutErrorCode =
  (typeof CHECKOUT_ERROR_CODE)[keyof typeof CHECKOUT_ERROR_CODE];
